module.exports = __webpack_public_path__ + "img/05车身控制器软件著作权.7d5e7042.png";